<template>
  <div class="rounded bg-grey_3 bordered pa-3 my-3" v-if="!masquer_activite">

    <div class="d-flex justify-space-between align-center flex-wrap flex-md-nowrap gap">
      <div>
        <h5 class="font-weight-bold">{{ activite.nom }}</h5>
        <div v-if="activite.get_metadata('infos_supp')">{{ activite.get_metadata("infos_supp") }}</div>
        <div v-if="activite.quantite != '0'">{{ infos_quantite_restante }}</div>
        <div v-else>{{ activite.nb_inscrits }} inscrits</div>
        <div v-if="$moment(activite.date_min).isValid()">Ouverture des inscriptions le {{
          $moment(activite.date_min).format("DD/MM/YYYY") }}</div>
        <div v-if="$moment(activite.date_max).isValid()">Fermeture des inscriptions le {{
          $moment(activite.date_max).format("DD/MM/YYYY") }}</div>
      </div>
      <div class="d-flex flex-column justify-center align-end">
        <div v-if="mainStore.billetterie_mode" class="mb-3">
          <v-btn class="inscription_btn shadowed" v-if="show_inscription_button" color="dark-green" size="default"
            variant="tonal" @click="$router.push({ name: 'Inscriptions' })"><v-icon icon="mdi-arrow-right-bold"
              class="mr-2"></v-icon> Réserver</v-btn>
          <v-btn v-else class="shadowed" color="dark-red" size="small" variant="tonal"><v-icon
              icon="mdi-pencil-off-outline"></v-icon> Inscriptions closes</v-btn>
        </div>
        <div class="text-h6">
          <span v-if="parseInt(activite.prix) > 0">{{ activite.prix }}€</span><span v-else>Gratuit</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";

export default {
  props: ["activite", "all_activites"],
  computed: {

    ...mapStores(useMainStore),
    masquer_activite() {
      const masquer_activite = this.activite.get_metadata("masquer_activite");
      if (masquer_activite && masquer_activite == "1") {
        return true;
      }
      if (!this.activite.visible_accueil) {
        return true;
      }
      return false;
    },
    infos_quantite_restante() {
      let quantite = this.activite.get_quantite_restante(this.all_activites);
      const masquer_places_restantes = this.activite.get_metadata("masquer_places_restantes");
      if (masquer_places_restantes && masquer_places_restantes == "1") {
        return "";
      }
      if (quantite == -1) {
        return "";
      }
      if (quantite == 0) {
        return "Complet";
      }
      return quantite + " places restantes";
    },
    show_inscription_button() {
      return this.activite.is_selectionnable(this.mainStore.module.status, this.mainStore.view_as_admin, this.mainStore.inscription_as_admin, this.mainStore.inscription_vip);
    },
  },
};
</script>

<style lang="scss" scoped></style>